import styled, { keyframes } from 'styled-components'
const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`
const slideOut = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  } 
`
export const Wrapper = styled.div`
  font-family: Montserrat, barlow, verdana, calibri !important;

  .mainHide {
    display: none !important;
  }
`
export const Main = styled.div`
  position: fixed;
  z-index: 1001;
  bottom: 90px;
  right: 15px;
  background: #fff;
  width: 350px;
  height: 550px;
  border-radius: 15px;
  animation: ${(props) => (props.isOpen ? slideIn : slideOut)} 0.5s ease-in-out;
  transition: opacity 0.5s linear;
`
export const Body = styled.div``
export const ContainerBoxMsg = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ type }) => (type === 'user' ? 'flex-end' : 'flex-start')};
`
export const BoxOptions = styled.div`
  display: ruby-text;
  margin: 5px 0 5px 30px;
`
export const BtnOption = styled.div`
  background: transparent;
  color: rgb(0, 123, 255);
  margin: 5px;
  padding: 8px;
  text-align: left;
  border: 1px solid rgb(0, 123, 255);
  border-radius: 10px !important;
  width: max-content;
  cursor: pointer;
  font-style: italic;
  font-size: 14px !important;
  font-weight: 100 !important;
  text-transform: unset;
  transition: all 0.5s ease 0s;
  &:hover {
    transition: 0.5s;
    background: #007bff;
    color: #fff;
    border: 1px solid rgb(0, 123, 255);
  }
  img {
    max-width: 14px;
    min-width: 14px;
    min-height: 14px;
    max-height: 14px;
  }
`
export const Message = styled.div`
  display: flex;
  justify-content: flex-end;

  margin: 5px 0;
`
export const BotMessage = styled(Message)`
  flex-direction: row-reverse;
  color: #6f42c1;
  margin-right: 35px;
  display: flex;
  align-items: flex-end;
  gap: 5px;
  border-radius: 10px;
  font-style: italic;
  font-weight: 100;

  img {
    max-width: 30px;
    max-height: 30px;
    min-width: 30px;
    min-height: 30px;
    object-fit: cover;
    overflow: hidden;

    background: #8e489c;
    padding: 2px;
    border-radius: 50%;
  }
  p {
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 10px 10px 10px 0px;
    margin: 0;

    img {
      max-width: 14px;
      min-width: 14px;
      min-height: 14px;
      max-height: 14px;
    }
  }
  div {
    align-items: flex-end;
  }
`
export const BotMessageConfirmation = styled(Message)`
  flex-direction: row-reverse;
  color: #8e489c;
  margin-right: 35px;
  display: flex;
  align-items: flex-end;
  gap: 5px;
  border-radius: 10px;
  font-style: italic;
  font-weight: 100;
  img {
    min-height: 30px;
    max-height: 30px;
    background: #8e489c;
    padding: 2px;
    border-radius: 50%;
  }
  p {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-color: #8be59ef5;
    padding: 11px;
    border-radius: 25px 25px 25px 0px;
    margin: 0;
    img {
      max-width: 14px;
      min-width: 14px;
      min-height: 14px;
      max-height: 14px;
    }
  }

  div {
    align-items: flex-end;
  }
`
export const UserMessage = styled(Message)`
  flex-direction: row;
  color: #fff;
  margin-left: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  p {
    background: #8e489c;
    padding: 10px;
    border-radius: 10px 0px 10px 10px;
    margin: 0;
  }
`
export const UserOption = styled.div`
  background: transparent;
  color: #007bff;
  text-align: left;
  width: max-content;
  font-style: italic;
  font-weight: 100;

  padding: 10px;
  border: 1px solid #007bff;
  border-radius: 10px 0px 10px 10px;
  margin: 0;
`

export const Content = styled.div`
  overflow: auto;
  height: 425px;
  padding: 15px;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 25px;

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #cccccc;
  }
`
